import React from "react"
import classNames from "utils/classNames"

export type CustomCalloutProps = React.ComponentProps<"div"> & {
  title?: React.ReactNode
}
const CustomCallout = ({
  title,
  children,
  className,
  ...props
}: CustomCalloutProps) => (
  <div className={classNames("vt-custom-callout", className)} {...props}>
    <h6 className="m-0">{title}</h6>
    <div className="vt-callout-body">{children}</div>
  </div>
)

export default CustomCallout
